<template>
  <div class="drag-scroll" 
       v-if="consumedApi === true"
       :style="{ height: dragAreaHeight + 'px' }"
  >
    <draggable  class="dragArea"
                v-model="products"
                tag="div"
                v-bind="dragOptions"
                delay-on-touch-only="true"
                delay="100"
                @start="drag=true"
                @end="
                    drag=false
                    verifyChange()
                "
    >
      <transition-group tag="ul" 
                        class="product-list" 
                        name="product-list"
      >
        <li  class="product-list__item" 
              v-for="product in products" 
              :key="product.id"
              :class="{ inactive: !product.active }"
        >
          <i class="inactive-icon"
              v-if="!product.active"
          >
          </i>
          <span class="product-stock"
                v-if="product.active"
          >
            Estoque: {{ product.stock }}
          </span>
          <figure>
            <BlurLoader :src='product.image' :smallSrc='product.image' />
          </figure>
          <figcaption>
            <span>SKU: {{ product.id }}</span>
            <div class="product-list__price">
              <span>de: R${{ product.old_price }}</span> <span>por: R${{ product.price }}</span>
            </div>
          </figcaption>
        </li>
      </transition-group>
    </draggable>
    <preloader class="observer" @intersect="loadMore"/>
  </div>
  <div  v-else-if="consumedApi === 'loading'"
  >
      <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
  </div>
  <div  v-else
        class="no-category-selected"
  >
      <i></i>
      <span>Nenhuma categoria selecionada.</span>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import axios from "axios"
import preloader from "./Preloader";
import BlurLoader from 'vue-blur-loader';

export default {
  data() {
    return {
      loading: [],
      products: [],
      consumedApi: false,
      limit: 999999,
      hasChange: false,
      dragAreaHeight: 0,
      category_id: 0,
      totalProducts: 0,
    };
  },
  created() {
    this.$root.$refs.Ordemvitrineproxy = this;
  },
  mounted() {
    this.dragAreaHeight = document.querySelector('body').clientHeight - document.querySelector('.category-select.select').clientHeight - 50
    window.addEventListener('resize', this.resizeDimensions);
  },
  computed: {
    dragOptions() {
      return {
        group: {
          name: 'g1'
        },
        forceFallback: true,
        scrollSensitivity: 200,
        scrollSpeed: 30,
        animation: 600,
      };
    },
  },
  methods: {
    resizeDimensions() {
      this.dragAreaHeight = document.querySelector('body').clientHeight - document.querySelector('.category-select.select').clientHeight - 50
    },
    getProducts: function(categoryId, storeId, productOrder, inputStatus) {
      let params;
      if(productOrder != null && inputStatus != null) {
          params = new URLSearchParams({
          "category_id": categoryId,
          "site_id": storeId,
          "order": productOrder,
          "inputStatus": inputStatus,
        })
      } else if(productOrder != null) {
        params = new URLSearchParams({
          "category_id": categoryId,
          "site_id": storeId,
          "order": productOrder,
        })
      } else if(inputStatus != null) {
        params = new URLSearchParams({
          "category_id": categoryId,
          "site_id": storeId,
          "inputStatus": inputStatus,
        })
      } else {
          params = new URLSearchParams({
          "category_id": categoryId,
          "site_id": storeId,
        });
      }
        axios
            .get(`/product/ordenate/products_by_category/`, { params })
            .then((res) => {
              this.loading = res.data.products
              const append = res.data.products.slice(this.products.length, this.products.length + this.limit)
              this.products = this.products.concat(append)
              this.$root.$refs.Categoryselect.totalProducts = res.data.count
              this.consumedApi = true
              this.dragAreaHeight = document.querySelector('body').clientHeight - document.querySelector('.category-select.select').clientHeight - 85
            })
            .catch((err) => {
              console.log(err)
            })
    },
    loadMore: function() {
      const append = this.loading.slice(this.products.length, this.products.length + this.limit)
      this.products = this.products.concat(append)
      if (this.loading.length === this.products.length) {
        this.$root.$refs.Preloader.destroyed()
      }
    },
    verifyChange: function() {
      if (this.hasChange === false) {
        this.hasChange = true
        this.$root.$refs.Categoryselect.needSave = true
      }
    },
  },
components: {
    draggable,
    preloader,
    BlurLoader
  },
};
</script>

<style>
#app {
  font-family: "Muli", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.drag-scroll {
  width: 100%;
  overflow-y: scroll;
  margin-top: 12px;
}

.observer {
  height: 50px;
  width: 100%;
  display: block;
}

.swal2-title {
  font-family: "Muli", Helvetica, Arial, sans-serif;
}

.product-list {
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 5px));
  grid-template-rows: 1fr;
  grid-gap: 5px;
  padding-left: 0;
  overflow-x: hidden;
  margin: 0;
  padding-bottom: 10px;
}

::-webkit-scrollbar {
  width: 5px !important;
  border: none !important;
  background-color: #fff !important;
}

::-webkit-scrollbar-thumb {
  background: #757575 !important;
  border-radius: 5px;
}

.grid-move {
  transition: all 0.3s;
}

.product-list__item {
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: grab;
  border: 0.5px solid #CCCCCC;
  min-height: 210px;
  padding: 5px;
}

.product-list__item .product-stock {
  position: absolute;
  top: 7px;
  left: 10px;
  z-index: 9;
  widows: 100%;
  color: #757575;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  text-align: left;
  line-height: 26px;
}

.product-list__item.inactive {
  border: 0.5px solid rgba(204, 204, 204, 0.4);
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #7141f6;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #7141f6 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.product-list__item.inactive figcaption {
  opacity: 0.4;
}

.product-list__item.inactive figure {
  opacity: 0.4;
}

.product-list__item.inactive .inactive-icon {
  width: 16px;
  height: 16px;
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMEMzLjU4ODg1IDAgMCAzLjU4ODg1IDAgOEMwIDEyLjQxMTIgMy41ODg4NSAxNiA4IDE2QzEyLjQxMTIgMTYgMTYgMTIuNDExMiAxNiA4QzE2IDMuNTg4ODUgMTIuNDExMiAwIDggMFpNOCAxMi4zMDQyQzcuODQ3ODYgMTIuMzA0MiA3LjY5OTE0IDEyLjI1OTEgNy41NzI2NCAxMi4xNzQ2QzcuNDQ2MTQgMTIuMDkwMSA3LjM0NzU1IDExLjk2OTkgNy4yODkzMiAxMS44Mjk0QzcuMjMxMSAxMS42ODg4IDcuMjE1ODcgMTEuNTM0MSA3LjI0NTU1IDExLjM4NDlDNy4yNzUyMyAxMS4yMzU3IDcuMzQ4NDkgMTEuMDk4NyA3LjQ1NjA3IDEwLjk5MTFDNy41NjM2NSAxMC44ODM1IDcuNzAwNzEgMTAuODEwMiA3Ljg0OTkzIDEwLjc4MDVDNy45OTkxNSAxMC43NTA5IDguMTUzODEgMTAuNzY2MSA4LjI5NDM3IDEwLjgyNDNDOC40MzQ5MyAxMC44ODI1IDguNTU1MDcgMTAuOTgxMSA4LjYzOTU5IDExLjEwNzZDOC43MjQxMiAxMS4yMzQxIDguNzY5MjMgMTEuMzgyOSA4Ljc2OTIzIDExLjUzNUM4Ljc2OTIzIDExLjczOSA4LjY4ODE5IDExLjkzNDcgOC41NDM5MyAxMi4wNzg5QzguMzk5NjcgMTIuMjIzMiA4LjIwNDAxIDEyLjMwNDIgOCAxMi4zMDQyWk04LjgzNTM4IDQuNTY3NjlMOC42MTQ2MiA5LjI2QzguNjE0NjIgOS40MjMyMSA4LjU0OTc4IDkuNTc5NzQgOC40MzQzNyA5LjY5NTE0QzguMzE4OTcgOS44MTA1NSA4LjE2MjQ0IDkuODc1MzkgNy45OTkyMyA5Ljg3NTM5QzcuODM2MDIgOS44NzUzOSA3LjY3OTUgOS44MTA1NSA3LjU2NDA5IDkuNjk1MTRDNy40NDg2OCA5LjU3OTc0IDcuMzgzODUgOS40MjMyMSA3LjM4Mzg1IDkuMjZMNy4xNjMwOCA0LjU3VjQuNTY4MDhDNy4xNTgyNCA0LjQ1NTM2IDcuMTc2MjYgNC4zNDI4MiA3LjIxNjA2IDQuMjM3MjVDNy4yNTU4NiA0LjEzMTY4IDcuMzE2NjIgNC4wMzUyNiA3LjM5NDY3IDMuOTUzNzlDNy40NzI3MiAzLjg3MjMxIDcuNTY2NDUgMy44MDc0OCA3LjY3MDIxIDMuNzYzMTlDNy43NzM5OCAzLjcxODkgNy44ODU2NCAzLjY5NjA3IDcuOTk4NDYgMy42OTYwN0M4LjExMTI5IDMuNjk2MDcgOC4yMjI5NCAzLjcxODkgOC4zMjY3MSAzLjc2MzE5QzguNDMwNDggMy44MDc0OCA4LjUyNDIxIDMuODcyMzEgOC42MDIyNiAzLjk1Mzc5QzguNjgwMzEgNC4wMzUyNiA4Ljc0MTA2IDQuMTMxNjggOC43ODA4NiA0LjIzNzI1QzguODIwNjYgNC4zNDI4MiA4LjgzODY4IDQuNDU1MzYgOC44MzM4NSA0LjU2ODA4TDguODM1MzggNC41Njc2OVoiIGZpbGw9IiNGRkI2NTQiLz4KPC9zdmc+Cg==)no-repeat 100%;
  position: absolute;
  top: 7px;
  left: 6px;
  z-index: 9;
}

.product-list__item:before {
  content: "";
  width: 10px;
  height: 16px;
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDEwIDE2Ij4KICA8cGF0aCBpZD0iZHJhZ19pbmRpY2F0b3JfRklMTDBfd2dodDQwMF9HUkFEMF9vcHN6NDgiIGQ9Ik0xNS43NSwyNGExLjc1LDEuNzUsMCwxLDEsMS4yMzctLjUxM0ExLjY4NiwxLjY4NiwwLDAsMSwxNS43NSwyNFptNi41LDBhMS43NSwxLjc1LDAsMSwxLDEuMjM3LS41MTNBMS42ODYsMS42ODYsMCwwLDEsMjIuMjUsMjRabS02LjUtNi4yNWExLjc1LDEuNzUsMCwxLDEsMS4yMzctLjUxM0ExLjY4NiwxLjY4NiwwLDAsMSwxNS43NSwxNy43NVptNi41LDBhMS43NSwxLjc1LDAsMSwxLDEuMjM3LS41MTNBMS42ODYsMS42ODYsMCwwLDEsMjIuMjUsMTcuNzVabS02LjUtNi4yNWExLjc1LDEuNzUsMCwwLDEtMS4yMzgtMi45ODgsMS43NSwxLjc1LDAsMCwxLDIuNDc1LDIuNDc1QTEuNjg2LDEuNjg2LDAsMCwxLDE1Ljc1LDExLjVabTYuNSwwYTEuNzUsMS43NSwwLDAsMS0xLjIzNy0yLjk4OCwxLjc1LDEuNzUsMCwwLDEsMi40NzUsMi40NzVBMS42ODYsMS42ODYsMCwwLDEsMjIuMjUsMTEuNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNCAtOCkiIGZpbGw9IiNjY2MiLz4KPC9zdmc+Cg==)no-repeat 100%;
  position: absolute;
  top: 7px;
  right: 6px;
  z-index: 9;
}

.product-list__item.sortable-chosen {cursor: grabbing;}

.product-list__item.sortable-chosen:after {
  content: "";
  width: 100%;
  height: 100%;
  background: rgba(10, 0, 255, 0.15);
  position: absolute;
  top: 0;
  left: 0;
}

.product-list__item figure {
  margin: 0;
  min-height: 150px;  
}

.product-list__item figure img {
  width: 100%;
  vertical-align: middle;  
}

.product-list__item figcaption {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.7);
}

.product-list__item figcaption .product-list__price {
  display: flex;
}

.product-list__item figcaption span {
  color: #757575;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding-left: 10px;
  text-align: left;
  width: 100%;
  line-height: 26px;
  display: block;
}
.no-category-selected {
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
    row-gap: 20px;
    margin-top: 100px;
}
.no-category-selected i{
    background: url(data:image/svg+xml;base64,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)no-repeat 100%;
    width: 90.71px;
    height: 104.9px;
    display: block;
    grid-row: 1/2;

}
.no-category-selected span {
    color: #3F51B5;
    font-size: 15px;
    font-weight: 400;
    grid-row: 2/3;
}
@media (min-width: 478px) {
    .product-list {
        grid-template-columns: repeat(3, calc(33.333333% - 10px));
    }
}
@media (min-width: 678px) {
    .product-list {
        grid-template-columns: repeat(4, calc(25% - 3.75px));
    }
}
@media (min-width: 892px) {
    .product-list {
        grid-template-columns: repeat(5, calc(20% - 4px));
    }
}
@media (min-width: 1150px) {
    .product-list {
        grid-template-columns: repeat(8, calc(12.5% - 4.375px));
    }
}
</style>